import React from 'react';
import PropTypes from 'prop-types';
const CLASS_NAME = 'asc-btn';
const propTypes = {
  /**
   * Click event handler for the link element
   **/
  analyticsHandler: PropTypes.func,
  /**
   * Additional classes to be added to the root link element
   **/
  className: PropTypes.string,
  /**
   * Href value for the link element
   **/
  link: PropTypes.string.isRequired,
  /**
   * Text to display in the link element
   **/
  text: PropTypes.string.isRequired
};
function ButtonLink(_ref) {
  let {
    analyticsHandler = () => {},
    className = '',
    link,
    text
  } = _ref;
  const clickHandler = () => {
    analyticsHandler();
  };
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    onClick: clickHandler,
    className: `${CLASS_NAME} ${className}`
  }, text);
}
ButtonLink.propTypes = propTypes;
export default ButtonLink;